module.exports = __webpack_public_path__ + "./assets/img_sanchong_grey__4854326f82b4867e3afb6f2af7befbeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_sanchong_grey.jpg
// module id = 622
// module chunks = 12